<template>
  <UkiModal :modalId="modalId" :title="title" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="wheel-price">Сумма колеса</label>
      <input id="wheel-price" :value="wheelPrice" required type="number"
             @input="$emit('update:wheelPrice', $event.target.value)"/>
    </div>
  </UkiModal>
</template>

<script>

import UkiModal from "@/components/UkiModal.vue"

export default {
  name: "EditPlatformInfoModal",
  components: {UkiModal},
  props: ["modalId", "platformName", "wheelPrice"],
  emits: ["update:wheelPrice", "close", "ok"],
  computed: {
    title: function () {
      return `Редактирование платформы ${this.platformName}`
    }
  }
}

</script>

<style scoped>

</style>